import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import { getFormData } from "../../../../helpers";

const NewCustomer = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const formType = params.location?.state;

  const [customerSince, setCustomerSince] = useState(null);

  const customerFormOptions = useSelector(
    (state) => state?.orderInvoicesReducer?.customerFormOptions
  );
  const customerEditData = useSelector(
    (state) => state?.orderInvoicesReducer?.customerEditData
  );

  const finalFormOptions =
    formType === "add" ? customerFormOptions : customerEditData;
  useEffect(() => {
    if (formType === "add") dispatch(actions?.getCustomersFormData());
    else {
      reset(customerEditData?.customer);
    }
  }, [customerEditData]);

  const defaultValues = {
    first_name: "",
    last_name: "",
    company_name: "",
    tax_id: "",
    category: "",
    customer_since: "",
    contact_name: "",
    contact_email: "",
    contact_number: "",
    contact_address1: "",
    contact_address2: "",
    contact_country: "",
    contact_state: "",
    contact_city: "",
    contact_zipcode: "",
    billing_name: "",
    billing_email: "",
    billing_number: "",
    billing_address1: "",
    billing_address2: "",
    billing_country: "",
    billing_state: "",
    billing_city: "",
    billing_zipcode: "",
    credit_terms: "",
    other_credit_term: "",
    interest_rate: "",
    receivable_account: "",
    default_payment_account: "",
  };

  const schema = yup.object().shape({
    first_name: yup.string().required(),
    last_name: yup.string().required(),
    category: yup.string().required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultValues,
  });

  function submitData(data) {
    console.log(data, "datadatadatadatadata");
    if (formType === "add")
      dispatch(
        actions?.postCustomersData({
          formData: data,
          history: history,
        })
      );
    else {
      dispatch(
        actions?.postCustomerEditData({
          formData: data,
          history: history,
        })
      );
    }
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <form onSubmit={handleSubmit(submitData)}>
            <div className="container px-0">
              <div className="row lbrSettingMs d-flex">
                <div className="col-xl-8 modify">
                  <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
                    <h4 className="event-alert w-100 mb-4">Customer Details</h4>
                    <div className="d-flex calc-height w-100 flex-wrap">
                      <div className="settings-left-content fixed-pos col-3">
                        <ul className="settingMenus">
                          <li id="AccDetail_li" className="active">
                            <a href="#_" id="AccDetail_dayTime_a">
                              Customer <br /> Info
                            </a>
                          </li>
                          <li id="Address_li" className="">
                            <a href="#_" id="Address_dayTime_a">
                              CONTACT <br /> DETAILS
                            </a>
                          </li>
                          <li id="FinSettings_li" className="">
                            <a href="#_" id="FinSettings_dayTime_a">
                              BILLING <br /> DETAILS
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="settings-right-content scrolling col-9">
                        <div className="date-sec-scroll">
                          <div
                            id="AccDetail_dayTime_div"
                            className="row-fluid scroll-change full_div"
                            day_time="AccDetail"
                          >
                            <div className="form-secs">
                              <h4> Customer Info </h4>
                              <ul class="ingredient-info edit-shift">
                                <Input
                                  label={"Customer First Name"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"first_name"}
                                />
                                <Input
                                  label={"Customer Last Name"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"last_name"}
                                />

                                <Input
                                  label={"Company Name"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"company_name"}
                                  notRequired
                                />

                                <Input
                                  label={"Company Tax ID"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"tax_id"}
                                  notRequired
                                />

                                <Select
                                  // onChange={(e) => handlePurpose(e)}
                                  label={"Category"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"category"}
                                  optionsArray={finalFormOptions?.categories}
                                />

                                <DateInput
                                  label={"Customer Since"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey="invoice_date"
                                  setFormField={setValue}
                                  dateVal={customerSince}
                                  horizontal={true}
                                  setDateVal={setCustomerSince}
                                />
                              </ul>
                            </div>
                          </div>

                          <div
                            id="Address_dayTime_div"
                            className="row-fluid scroll-change full_div"
                            day_time="Address"
                          >
                            <div className="form-secs">
                              <h4> Contact Details </h4>

                              <ul class="ingredient-info edit-shift">
                                <Input
                                  label={"Name"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_name"}
                                />
                                <Input
                                  label={"Email"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_email"}
                                />

                                <Input
                                  label={"Contact Number"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_number"}
                                  notRequired
                                />
                                <Input
                                  label={"Address Line #1"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_address1"}
                                />

                                <Input
                                  label={"Address Line #2"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_address2"}
                                  notRequired
                                />

                                <Select
                                  onChange={(e) =>
                                    dispatch(
                                      actions?.getCustomersFormContactStates({
                                        id: e.target.value,
                                        formType,
                                      })
                                    )
                                  }
                                  label={"Country"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_country"}
                                  optionsArray={finalFormOptions?.countries}
                                />
                                <Select
                                  label={"State"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_state"}
                                  optionsArray={finalFormOptions?.contactStates}
                                />

                                <Input
                                  label={"City"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_city"}
                                  notRequired
                                />
                                <Input
                                  label={"Contact Zipcode"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"contact_zipcode"}
                                  notRequired
                                />
                              </ul>
                            </div>
                          </div>

                          <div
                            id="FinSettings_dayTime_div"
                            className="row-fluid scroll-change full_div"
                            day_time="FinSettings"
                          >
                            <div className="form-secs">
                              <h4> Billing Details </h4>

                              <ul class="ingredient-info edit-shift">
                                <Input
                                  label={"Name"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_name"}
                                />
                                <Input
                                  label={"Email"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_email"}
                                />

                                <Input
                                  label={"billing Number"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_number"}
                                  notRequired
                                />
                                <Input
                                  label={"Address Line #1"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_address1"}
                                />

                                <Input
                                  label={"Address Line #2"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_address2"}
                                  notRequired
                                />

                                <Select
                                  onChange={(e) =>
                                    dispatch(
                                      actions?.getCustomersFormBillingStates({
                                        id: e.target.value,
                                        formType,
                                      })
                                    )
                                  }
                                  label={"Country"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_country"}
                                  optionsArray={finalFormOptions?.countries}
                                />
                                <Select
                                  label={"State"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_state"}
                                  optionsArray={finalFormOptions?.billingStates}
                                />

                                <Input
                                  label={"City"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_city"}
                                  notRequired
                                />
                                <Input
                                  label={"Contact Zipcode"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"billing_zipcode"}
                                  notRequired
                                />
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 payment-terms d-flex">
                  <div className="shadowclass mt-4">
                    <h4 className="event-alert">Payment Terms </h4>

                    <ul class="ingredient-info payPerform">
                      <Select
                        label={"Credit Terms"}
                        formRegister={register}
                        formError={errors}
                        formKey={"credit_terms"}
                        optionsArray={finalFormOptions?.credit_terms}
                      />

                      <Input
                        label={"Interest Rate"}
                        formRegister={register}
                        formError={errors}
                        formKey={"interest_rate"}
                        notRequired
                      />

                      <Select
                        label={"Default Accts Receivable Account"}
                        formRegister={register}
                        formError={errors}
                        formKey={"receivable_account"}
                        optionsArray={finalFormOptions?.yes_no}
                      />
                      <Select
                        label={"Default Payment Account"}
                        formRegister={register}
                        formError={errors}
                        formKey={"default_payment_account"}
                        optionsArray={finalFormOptions?.yes_no}
                      />
                    </ul>
                  </div>
                </div>
              </div>

              <div class="row mx-0">
                <div class="container px-0 d-flex col-12">
                  <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                    <button
                      onClick={() => history.push("/order/customers")}
                      id="cancel"
                      type="button"
                    >
                      Cancel
                    </button>
                    <button id="" type="Submit">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </UserInterface>
  );
};
export default NewCustomer;
